<template>
<fade-in-component>
  <div class="details-list">

    <article class="job-card" v-for="job in jobs" :key="job.slug">
      <router-link v-if="job.slug!=jobslug" :to="setLink(job.slug)" class="joblink">
        <h4 class="jobtitl">{{job.name}}</h4>
        <div class="jobimg">
          <img :src="setImgPath(job.slug,'obj')" :alt="job.name" class="imgobj" :class="setClassName(job.slug)">
          <img :src="setImgPath(job.slug,'person')" :alt="job.name" class="imgperson" :class="setClassName(job.slug)">
        </div>
        <p class="jobtxt">{{job.text}}</p>
      </router-link>
      <router-link v-if="job.slug!=jobslug" :to="setLink(job.slug)" class="linkbtn">
        詳しく見る
      </router-link>

      <a v-if="job.slug==jobslug" href="#" class="joblink" @click="scrollTop">
        <h4 class="jobtitl">{{job.name}}</h4>
        <div class="jobimg">
          <img :src="setImgPath(job.slug,'obj')" :alt="job.name" class="imgobj" :class="setClassName(job.slug)">
          <img :src="setImgPath(job.slug,'person')" :alt="job.name" class="imgperson" :class="setClassName(job.slug)">
        </div>
        <p class="jobtxt">{{job.text}}</p>
      </a>
      <a v-if="job.slug==jobslug" href="#" class="linkbtn" @click="scrollTop">
        詳しく見る
      </a>      

    </article>

  </div>
  <router-link to="/" class="backtotoppage">トップページに戻る</router-link>
</fade-in-component>  
</template>

<script>
import FadeInComponent from "../components/FadeInComponent.vue";

export default {
  props: ["job"],
  components: {
    FadeInComponent
  },
  data(){
    return{
      jobslug: this.job,
      jobs: [
        {
          name: "人材",
          slug: "staffagency",
          text: "自信を持ちつつ\n慎重に考えるゼネラリスト",
        },
        {
          name: "IT",
          slug: "it",
          text: "内向的かつ理論重視",
        },
        {
          name: "食品",
          slug: "foodcompany",
          text: "外向的で大胆な\nパートナー",
        },
        {
          name: "ディーラー",
          slug: "cardealer",
          text: "型にはまらない\n心配性な専門家",
        },
        {
          name: "商社",
          slug: "shosha",
          text: "外向的で大胆な\nパートナー",
        },
        {
          name: "保険",
          slug: "insurance",
          text: "自信と慎重さを\n併せもったパートナー",
        },
        {
          name: "銀行",
          slug: "bank",
          text: "規律を重視する自信家",
        },
        {
          name: "不動産",
          slug: "estate",
          text: "大胆かつ好戦的な\nゼネラリスト",
        },
        {
          name: "製薬",
          slug: "mr",
          text: "外向的なゼネラリスト",
        },
        {
          name: "証券",
          slug: "securities",
          text: "規律を重視する専門家",
        }
      ]     
    }
  },
  methods: {
    scrollTop(e) {
      e.preventDefault();
      // console.log(e);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }  
  },  
  computed: {
    setClassName() {
      return function (val) {
        return "-" + val;
      };
    },
    setLink() {
      return function (val) {
        if ( this.jobslug == val ){
          return "#";
        }else{
          return "/" + val;
        }
      };
    },
    setImgPath() {
      return function (val,fn) {
        // return "../assets/img/" + val + "/" + fn + ".svg";
        return require("@/assets/img/" + val + "/" + fn + ".svg");
      };
    },
  },
};
</script>